"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = withConfirmationModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ConfirmationModal_1 = __importDefault(require("@components/Modal/ConfirmationModal"));
function withConfirmationModal(WrappedComponent) {
    return function WithModalComponent(props) {
        var _a = (0, react_1.useState)(false), isConfirmationVisible = _a[0], setConfirmationVisible = _a[1];
        var _b = (0, react_1.useState)(""), text = _b[0], setConfirmationText = _b[1];
        var callbackRef = (0, react_1.useRef)(null);
        function showConfirmationModal(confirmText, callback) {
            setConfirmationText(confirmText);
            callbackRef.current = callback;
            setConfirmationVisible(true);
        }
        function handleConfirm() {
            if (callbackRef.current) {
                callbackRef.current();
            }
            setConfirmationVisible(false);
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(WrappedComponent, __assign({}, props, { showConfirmationModal: showConfirmationModal })), (0, jsx_runtime_1.jsx)(ConfirmationModal_1.default, { isOpen: isConfirmationVisible, setOpen: setConfirmationVisible, onConfirm: handleConfirm, text: text })] }));
    };
}
